"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = index;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _react = _interopRequireDefault(require("react"));

var _Title = _interopRequireDefault(require("../../Title"));

function index(props) {
  var style = props.style,
      flexTitle = props.flexTitle,
      description = props.description,
      headerTitle = props.headerTitle,
      _a = props.headerList,
      headerList = _a === void 0 ? [] : _a,
      _b = props.mainList,
      mainList = _b === void 0 ? [] : _b,
      tab = props.tab,
      title = props.title;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "publish-price-container",
    style: (0, _typeof2["default"])(style) === 'object' ? style : {}
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "publish-price-wrap"
  }, flexTitle && /*#__PURE__*/_react["default"].createElement(_Title["default"], {
    title: flexTitle,
    desc: description
  }), title && /*#__PURE__*/_react["default"].createElement("div", {
    className: "publish-price-small-title"
  }, title), /*#__PURE__*/_react["default"].createElement("div", {
    className: "publish-price-main",
    style: tab ? {
      marginBottom: 40,
      marginLeft: 0,
      marginRight: 0
    } : {}
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "publish-price-main-header"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "publish-price-main-header-one"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "publish-price-main-header-one-txt"
  }, headerTitle)), headerList === null || headerList === void 0 ? void 0 : headerList.map(function (item, index) {
    var title = item.title,
        desc = item.desc;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "publish-price-main-header-wrap",
      key: index
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "publish-price-main-header-title"
    }, title), desc ? /*#__PURE__*/_react["default"].createElement("div", {
      className: "publish-price-main-header-desc"
    }, desc) : null);
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "publish-price-main-content-wrap"
  }, mainList === null || mainList === void 0 ? void 0 : mainList.map(function (item, index) {
    var columnTitle = item.columnTitle,
        _a = item.contentList,
        contentList = _a === void 0 ? [] : _a;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "publish-price-main-content",
      key: index
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "publish-price-main-content-title"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "publish-price-main-content-title-txt"
    }, columnTitle)), contentList === null || contentList === void 0 ? void 0 : contentList.map(function (item, index) {
      var title = item.title,
          desc = item.desc;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "publish-price-main-content-item",
        key: index
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "publish-price-main-content-item-title"
      }, title), desc ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "publish-price-main-content-item-desc"
      }, desc) : null);
    }));
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "publish-price-main-mo"
  }, mainList === null || mainList === void 0 ? void 0 : mainList.map(function (item, index) {
    var columnTitle = item.columnTitle,
        _a = item.contentList,
        contentList = _a === void 0 ? [] : _a;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "publish-price-main-content-mo",
      key: index
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "publish-price-main-content-title-mo"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "publish-price-main-content-title-txt-mo"
    }, columnTitle)), /*#__PURE__*/_react["default"].createElement("div", {
      className: "publish-price-main-content-list-mo"
    }, contentList === null || contentList === void 0 ? void 0 : contentList.map(function (item, index) {
      var title = item.title,
          desc = item.desc;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "publish-price-main-content-item-mo",
        key: index
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "publish-price-main-content-item-title-wrap-mo"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "publish-price-main-content-item-title-mo"
      }, title), desc ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", null, " / "), /*#__PURE__*/_react["default"].createElement("div", {
        className: "publish-price-main-content-item-desc-mo"
      }, desc)) : null), headerList === null || headerList === void 0 ? void 0 : headerList.map(function (hItem, i) {
        var title = hItem.title,
            desc = hItem.desc;
        if (index !== i) return null;
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "publish-price-main-content-item-header-wrap-mo",
          key: i
        }, title, " \xA0\xA0", desc ? desc : null);
      }));
    })));
  }))));
}